import React, {SyntheticEvent} from 'react';

import {Link} from 'react-router-dom';

import s from './searchResults.scss';
import {QuickSearchItemType, QuickSearchResultsType} from '../types';
import {getLinkProps, getSearchResultName} from './utils';
import {CloudinaryImage} from 'components/cloudinaryImage/cloudinaryImage';
import {HEADER, sendMobileAnalyticsEvent} from '@optimaxdev/analytics/mobile';
import {EmptyActionType} from 'constants/flow/flowTypes';
import {Loader} from 'components/__helpers/loader/loader';

export const PRODUCT_CLICKED_ACTION = 'Product Clicked';
export const AUTOCOMPLETE_CLICKED_ACTION = 'Autocomplete Chip Clicked';

export type SearchDescribeActionType =
    | typeof PRODUCT_CLICKED_ACTION
    | typeof AUTOCOMPLETE_CLICKED_ACTION;

type PropsType = {
    results: QuickSearchResultsType;
    onClick: () => void;
    goSearchPage: (event: SyntheticEvent, withAnalytics?: boolean) => void;
    query: string;
    isLoading: boolean;
    onSelectSearchResult: (
        value: string,
    ) => EmptyActionType<{
        value: string;
    }>;
};

/**
 * searchResultsContent
 * @returns {FC} - component
 */
export const SearchResults: React.FC<PropsType> = ({
    isLoading,
    onClick,
    onSelectSearchResult,
    query,
    results,
}) => {
    const getHandlerClickOnLink = (name: string, actionDescribe: SearchDescribeActionType) => {
        sendMobileAnalyticsEvent(HEADER.SEARCH, {
            actionDescribe: ` - ${actionDescribe}`,
            label: name,
        });

        onSelectSearchResult(name);
        onClick();
    };

    if (isLoading) {
        return (
            <div className={s.container}>
                <Loader className={s.loader} />
            </div>
        );
    }

    if (!results?.productsList?.length && !results?.queriesList?.length) {
        return (
            <div className={s.container}>
                <div className={s.emptyResults}>Oops, No results were found</div>
            </div>
        );
    }

    return (
        <div className={s.container}>
            <ul>
                {[...results.queriesList, ...results.productsList].map(
                    (item: QuickSearchItemType) => (
                        <li key={item.name} className={s.resultItem}>
                            <Link
                                to={getLinkProps(item.link)}
                                className={s.link}
                                onClick={() =>
                                    getHandlerClickOnLink(
                                        item.name,
                                        'image' in item && item.image
                                            ? PRODUCT_CLICKED_ACTION
                                            : AUTOCOMPLETE_CLICKED_ACTION,
                                    )
                                }
                            >
                                {'image' in item && item.image && (
                                    <span className={s.image}>
                                        <CloudinaryImage src={item.image} alt={item.name} />
                                    </span>
                                )}
                                <span
                                    className={s.linkText}
                                    dangerouslySetInnerHTML={{
                                        __html: getSearchResultName(item.name, query),
                                    }}
                                />
                            </Link>
                        </li>
                    ),
                )}
            </ul>
        </div>
    );
};
